import { render, staticRenderFns } from "./UploadStatusTable.vue?vue&type=template&id=2dfdc129&"
import script from "./UploadStatusTable.vue?vue&type=script&lang=js&"
export * from "./UploadStatusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports